var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,19.5A19.5,19.5,0,1,1,19.5,0,19.5,19.5,0,0,1,39,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.78,15.31a2.26,2.26,0,0,1-4.51,0,2.26,2.26,0,0,1-4.51,0,2.27,2.27,0,0,1-4.52,0A2.16,2.16,0,0,1,15,17.38a2.17,2.17,0,0,1-2.26-2.07,2.16,2.16,0,0,1-2.25,2.07,2.17,2.17,0,0,1-2.26-2.07",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.41,17.38v10.1a1.79,1.79,0,0,1-1.79,1.79H12.38a1.79,1.79,0,0,1-1.79-1.79V17.38M8.22,15.31l2.55-4.19a1.43,1.43,0,0,1,1.29-.82H26.94a1.43,1.43,0,0,1,1.29.82l2.55,4.19",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.26,
    y: 20.6,
    width: 10.47,
    height: 5.1,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.86278177d894a9a8ddae5de4d6a57247.svg";
export { ForwardRef as ReactComponent };